// "I have a passcode" — the code THE WALL gave a band signs this anonymous session in to that band's own page.
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { API } from "../../App";

export const bandKeyName = (sid) => `wall_band_key_${sid}`;

export const PasscodeLogin = ({ sessionId, onSignedIn, again = false }) => {
  const [open, setOpen] = useState(again);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const digits = code.replace(/\D/g, "");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await axios.post(`${API}/musician/${sessionId}/claim`, { passcode: digits });
      localStorage.setItem(bandKeyName(sessionId), data.band_key);
      toast.success(`Signed in to ${data.band_name}`);
      onSignedIn(data.session);
    } catch (e2) { setErr(e2.response?.data?.detail || "That didn't work — try again"); }
    setBusy(false);
  };
  return (
    <section className={`rounded-2xl border-2 ${again ? "border-amber-400 bg-amber-50" : "border-[#2E5C55]/30 bg-white"} p-5 mb-5`} data-testid="musician-passcode">
      <div className="flex items-center gap-2 flex-wrap">
        <KeyRound className="h-5 w-5 text-[#2E5C55]" />
        <h2 className="m-0 font-bold text-lg text-[#1A1A1A]">{again ? "Enter your passcode again" : "Got a passcode from THE WALL?"}</h2>
        {!open && <button type="button" onClick={() => setOpen(true)} className="ml-auto rounded-full bg-[#2E5C55] text-white px-4 py-1.5 text-xs font-bold" data-testid="musician-passcode-open">I have a passcode</button>}
      </div>
      <p className="m-0 mt-1 text-sm text-[#5C5C5C]">{again ? "Your passcode was changed or this device was signed out. Type the newest one to keep editing your band page." : "It signs you straight in to your own band page — update it and add shows any time. It only opens your page."}</p>
      {open && (
        <form onSubmit={submit} className="mt-3 flex flex-col sm:flex-row gap-2" data-testid="musician-passcode-form">
          <input value={code} onChange={(e) => setCode(e.target.value.replace(/[^\d\s-]/g, "").slice(0, 26))} inputMode="numeric" autoComplete="one-time-code" placeholder="Your passcode — numbers only" className="flex-1 rounded-lg border border-[#E2E0DC] px-3 py-2.5 text-base tracking-[0.2em] font-bold tabular-nums focus:outline-none focus:ring-2 focus:ring-[#2E5C55]/40" data-testid="musician-passcode-input" />
          <button type="submit" disabled={busy || digits.length < 9} className="rounded-full bg-[#1A1A1A] text-white px-5 py-2.5 text-sm font-bold disabled:opacity-40 inline-flex items-center justify-center gap-1.5" data-testid="musician-passcode-submit">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in to my page</button>
        </form>
      )}
      {err && <p className="m-0 mt-2 text-sm text-red-600" data-testid="musician-passcode-error">{err}</p>}
    </section>
  );
};
